module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "layer-1-copy-1.f9222645.png";